import React from 'react';
import {Button, Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './BackButton.module.scss';

type BackButtonProps = {
  onBack?: () => void;
};

const backButtonIconStyle = {
  width: '20px',
  height: '20px',
};

function BackButton({onBack}: BackButtonProps) {
  return (
    <Button
      variant="outlined"
      size="small"
      onClick={onBack}
      className={styles.button}
      startIcon={
        <Icon
          name="Actions-Arrow-Back-Small"
          size="medium"
          appearance="primary"
          style={backButtonIconStyle}
        />
      }
    >
      {translate('Back')}
    </Button>
  );
}

export default BackButton;
